'use strict';

module.exports = ['$scope', '$rootScope', 'ngDroUtilsNotify', 'CanDoServices', '$state', 'ngDroUAA', '$templateCache', '$timeout',
    function ($scope, $rootScope, ngDroUtilsNotify, CanDoServices, $state, ngDroUAA, $templateCache, $timeout) {

        /*
         * Config
         */
        $templateCache.put('companyNodeTree.html', require('./templates/companyNodeTree.html'));

        /*
         * Methods
         */

        //  Creazione di una nuova CompanyDistrict.
        $scope.addLeaf = function (companyFather) {
            var company = {
                parent: companyFather.id
            };
            // passo in questo modo l'oggetto padre all'altro controller
            $rootScope.company_father = companyFather;
            $state.go('uaa-module-company-add');
        };

        //
        $scope.edit = function (node) {
            $state.go('uaa-module-company-edit', {id: node.id});
        };

        // Funzione che controlla se una determinata Company District ha dei figli.
        $scope.hasLeaf = function (companyFather) {
            $scope.hasLeafs = false;
            ngDroUAA.Company.leafs(companyFather.id).then(function (response) {
                var leafs = response.data;
                if (leafs && leafs.length > 0) {
                    $scope.hasLeafs = true;
                }
            });
        };

        // Cancellazione di un nodo.
        $scope.deleteNode = function (company) {
            var options = {
                success: function () {
                    /*
                     * Controllo se esiste qualche CompanyDistrict figlia dell'elemento che sto andando
                     * a rimuovere. Nel caso in cui esistono dei figli non sarà possibile eliminare la 
                     * CompanyDistrict.
                     */
                    ngDroUAA.Company.leafs(company.id).then(function (response) {
                        var leafs = response.data;
                        /*
                         * Se possiede dei figli visualizzo una notifica di errore. 
                         */
                        if (leafs && leafs.length > 0) {
                            ngDroUtilsNotify.deleteError(company.name);
                        } else {
                            /**
                             * Procedo all'effettiva rimozione 
                             * della CompanyDistrict.
                             */
                            ngDroUAA.Company.delete(company.id)
                                    .then(function () {
                                        $rootScope.loadCompanyTree();
                                        ngDroUtilsNotify.deleteSuccess(company.name);
                                    })
                                    .catch(function (err) {
                                        ngDroUtilsNotify.deleteError(company.name, err);
                                    });
                        }
                    });
                },
                itemTitle: company.name,
                headTitle: 'jdro_company.confirm_delete'
            };
            ngDroUtilsNotify.confirmDelete(options);
        };

        // Funzione che identifica la company da aggiornare ed effettuo la chiamata REST per aggiornare quella specifica CompanyDistrict.
        $scope.movedCompany = function (root) {

            if ($scope.jdroPerms.UPDATE === true) {

                angular.forEach(root.leafs, function (companyDTO) {

                    if (companyDTO.parent !== root.id) {

                            ngDroUAA.Company.findOne(companyDTO.id).then(function (response) { // devo settare l'id del padre e il nodePath
                                var company = response.data
                                company.parent = root.id;
                                company.nodePath = root.id + "/";
                                company.nodePath = root.nodePath + company.nodePath;

                                ngDroUAA.Company.update(company)
                                        .then(function () {
                                            ngDroUtilsNotify.updateSuccess(company.name);
                                            $rootScope.loadCompanyTree();
                                        })
                                        .catch(function (err) {
                                            ngDroUtilsNotify.updateError(company.name, err);
                                        });
                            });
                        }
                    $scope.movedCompany(companyDTO);
                });
            } else {
                ngDroUtilsNotify.error(null, 'core_notify_perms.denied');
            }
        };

        $scope.treeOptions = {
            /*
             * Nel momento in cui arrivo qua ho il DTO 
             * pronto per essere aggiornato.
             */
            dragStop: function (event) {
                // $timeout risolve un bug
                $timeout(function () {
                    $scope.movedCompany($scope.companyTree[0]);
                }, 200);
            }
        };

        // Il toggle è necessario per la chiusura e l'apertura di una foglia che possiede dei figli.
        $scope.toggle = function (scope) {
            scope.toggle();
        };

        $scope.collapseAll = function () {
            $scope.$broadcast('collapseAll');
        };

        $scope.expandAll = function () {
            $scope.$broadcast('expandAll');
        };

        $rootScope.loadCompanyTree = function () {
            ngDroUAA.Company.tree()
                    .then(function (response) {
                        $scope.companyTree = response.data;
                    })
                    .catch(function (err) {
                        ngDroUtilsNotify.error(null, 'jdro_company.error.find_all', null, err);
                    });
            ;
        };

        /*
         * Init
         */

        // Ottengo i permessi per le operazioni Update, Create, Delete
        CanDoServices.canDo("COMPANY_DISTRICT").then(function (perms) {
            $scope.jdroPerms = perms;
        });

        //Caricamento dell'albero delle CompanyDistrict.
        $rootScope.loadCompanyTree();
    }];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/components/company/companyList/companyListCtrl.js
// module id = 426
// module chunks = 0